import { useFormContext } from 'react-hook-form';

import { AlignmentQuestion } from './AlignmentQuestion';
import { BlockersQuestion } from './BlockersQuestion';
import { DepartureRiskQuestion } from './DepartureRiskQuestion';
import { DevelopmentPathQuestion } from './DevelopmentPathQuestion';
import { SupportNeedsQuestion } from './SupportNeedsQuestion';

import type { CareerAspirationFormValues } from './careerAspirationValidation';
import type { CareerAspirationQuestionProps } from './types';

/**
 * The five questions of the "Aspirations de carrière" meeting, in the order the results section
 * shows them, bound through the form context to whichever screen owns the form (the Growth tab's
 * editor modal, the career meeting's plan) -- see `useCareerAspirationForm`. The follow-ups each
 * question adds are the ones the picked path calls for, so both read the path itself rather than a
 * rule of their own.
 */
export const CareerAspirationForm = ({
    employeeFirstName,
    dataTestId,
}: CareerAspirationQuestionProps) => {
    const { watch } = useFormContext<CareerAspirationFormValues>();
    const developmentPath = watch('developmentPath');

    return (
        <div
            className={'flex flex-col gap-5'}
            data-testid={dataTestId}
        >
            <DevelopmentPathQuestion
                employeeFirstName={employeeFirstName}
                developmentPath={developmentPath}
                dataTestId={dataTestId}
            />
            <AlignmentQuestion
                employeeFirstName={employeeFirstName}
                developmentPath={developmentPath}
                dataTestId={dataTestId}
            />
            <SupportNeedsQuestion
                employeeFirstName={employeeFirstName}
                dataTestId={dataTestId}
            />
            <BlockersQuestion dataTestId={dataTestId} />
            <DepartureRiskQuestion
                employeeFirstName={employeeFirstName}
                dataTestId={dataTestId}
            />
        </div>
    );
};
